export const sendstucredApi = {

    data:[
        {
            name:"Id",
            value:"12"
        },
        {
            name:"Name",
            value:"Safayet"
        },
        {
            name:"Class",
            value:"Class 7"
        },
        {
            name:"Section",
            value:"Diamond 1"
        },
        {
            name:"Status",
            value:"Active"
        },
        
    ]
}
export const credinfostuApi = {

    data:[
        {
            name:"User Name",
            value:"Safayet"
        },
        {
            name:"Password",
            value:"123456"
        },
        {
            name:"Password Received",
            value:"123456"
        },
        {
            name:"Last Password Received",
            value:"123456"
        },
        {
            name:"Mobile Number",
            value:"015465465"
        },
        
    ]
}

